import { createSelector } from '@reduxjs/toolkit';
import { getImmutableCompatible } from 'src/utils/immutableUtils';
import { getIsWhitelabel } from '../view/selectors';

const getClient = (state) => getImmutableCompatible(state, 'client');

export const getShowAuthPopup = (state) =>
  getClient(state).get('showAuthPopup');
export const getShowLogOutPopup = (state) =>
  getClient(state).get('showLogOutPopup');
export const getClientAuthToken = (state) => getClient(state).get('authToken');
export const getClientId = (state) => getClient(state).get('id');
export const getClientName = (state) => getClient(state).get('name');
export const getClientSurname = (state) => getClient(state).get('surname');
export const getClientNameEn = (state): string =>
  getClient(state).get('name_en');
export const getClientSurnameEn = (state): string =>
  getClient(state).get('surname_en');
export const getClientPhone = (state) => getClient(state).get('phone');
export const getClientUnconfirmedPhone = (state) =>
  getClient(state).get('unconfirmed_phone');
export const getClientEmail = (state) => getClient(state).get('email');
export const getClientUnconfirmedEmail = (state) =>
  getClient(state).get('unconfirmed_email');
export const getConfirmedAt = (state) => getClient(state).get('confirmed_at');
export const getAvatar = (state) => getClient(state).get('avatar');

export const getIsLoggedIn = createSelector(getClientId, (id): boolean =>
  Boolean(id),
);

export const isPhoneConfirmedSelector = createSelector(
  [getClientUnconfirmedPhone],
  (unconfirmedPhone) => !unconfirmedPhone,
);

export const getClientData = (state) =>
  getClientId(state)
    ? {
        id: getClientId(state),
        name: getClientName(state),
        surname: getClientSurname(state),
        phone: getClientPhone(state) || getClientUnconfirmedPhone(state),
        email: getClientEmail(state) || getClientUnconfirmedEmail(state),
      }
    : null;

/**
 * Бонусы накопленные клиентом
 */
export const getClientBonusScore = (state) =>
  getClient(state).get('bonus_score') || 0;

export const getCashbackPriceReductionCount = createSelector(
  getClientBonusScore,
  getIsLoggedIn,
  getIsWhitelabel,
  (count, isLoggedIn, isWhiteLabel) =>
    isLoggedIn && !isWhiteLabel && count > 0 ? count : null,
);

/**
 * Коэффицент используется для апгрейда номера
 */
export const getCoefForRoomUpgrade = (state) =>
  getClient(state).get('coefficient_for_room_upgrade') || 0;

/**
 * Данные клиента для фронтовой аналитики
 */
export const getClientStatsData = createSelector(
  [getClientId, getClientEmail, getClientPhone],
  (id, email, phone) => ({ id, email, phone }),
);
